/**
 * Custom event system for profile image updates
 * Allows real-time synchronization of profile images across components
 */

export interface ProfileImageUpdateEvent {
	userId: string;
	newImageUrl: string;
}

const PROFILE_IMAGE_UPDATE_EVENT = "profile-image-update";

/**
 * Dispatch a profile image update event
 */
export function dispatchProfileImageUpdate(
	userId: string,
	newImageUrl: string,
): void {
	const event = new CustomEvent<ProfileImageUpdateEvent>(
		PROFILE_IMAGE_UPDATE_EVENT,
		{
			detail: { userId, newImageUrl },
		},
	);
	window.dispatchEvent(event);
}

/**
 * Add a listener for profile image update events
 * @returns Cleanup function to remove the listener
 */
export function addProfileImageUpdateListener(
	callback: (event: ProfileImageUpdateEvent) => void,
): () => void {
	const handler = (event: Event) => {
		const customEvent = event as CustomEvent<ProfileImageUpdateEvent>;
		callback(customEvent.detail);
	};

	window.addEventListener(PROFILE_IMAGE_UPDATE_EVENT, handler);

	// Return cleanup function
	return () => {
		window.removeEventListener(PROFILE_IMAGE_UPDATE_EVENT, handler);
	};
}
